<template>
  <button
    :disabled="!isSelectable"
    class="export-content__integration-button"
    :class="{
      ['export-content__integration-button-' + name]: true,
      'export-content__integration-button-selected': isSelected,
    }"
  >
    <div>
      <img class="export-content__integration-button-logo" :src="imageUrl" />
      <img
        class="export-content__integration-button-logo-dark"
        :src="darkImageUrl"
      />
    </div>
    <div class="export-content__integration-button-text">
      <h5 class="export-content__integration-button-title">{{ name }}</h5>
      <p class="export-content__integration-button-description">
        {{ description }}
      </p>
    </div>

    <p
      class="export-content__integration-state-label"
      :class="{
        'export-content__integration-label-coming-soon': !isSelectable,
        'export-content__integration-label-connected': isEnabled,
      }"
    >
      {{ parsedState }}
    </p>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    name: string
    description: string
    imageUrl: string
    darkImageUrl: string
    isSelected?: boolean
    isSelectable?: boolean
    isEnabled?: boolean
  }>(),
  {
    isSelected: false,
    isSelectable: true,
    isEnabled: false,
  },
)

const parsedState = computed(() => {
  if (!props.isSelectable) {
    return 'Coming Soon'
  }
  if (props.isEnabled) {
    return 'Connected'
  }
  return ''
})
</script>
